export class TermsAndConditions {
  version: number;
  content: string;
  dateUpdated: Date;
}
